// extracted by mini-css-extract-plugin
export default {"cautionBox":"Lba-z"};